import styled from 'styled-components';
import { Base, Theme } from 'styled';

export const Button = styled(Base)`
  &:not(:last-of-type) {
    margin-right: 0.5rem;
  }
`;

export const Svg = styled(Base)`
  width: ${({ theme }) => theme.sizes.socialShareIconMobile};
  height: ${({ theme }) => theme.sizes.socialShareIconMobile};

  ${Theme.mediaQueries.md} {
    width: ${({ theme }) => theme.sizes.socialShareIconDesktop};
    height: ${({ theme }) => theme.sizes.socialShareIconDesktop};
  }
`;
